import { library, config } from '@fortawesome/fontawesome-svg-core'
import { defineAsyncComponent } from 'vue'

// Solid icons (fas)
import {
    faAddressCard,
    faAlignCenter,
    faAlignJustify,
    faAlignLeft,
    faAlignRight,
    faAnchor,
    faAngleLeft,
    faAngleRight,
    faAppleAlt,
    faArchive,
    faArrowDown,
    faArrowLeft,
    faArrowPointer,
    faArrowRight,
    faArrowUp,
    faAt,
    faAtom,
    faAward,
    faBalanceScale,
    faBan,
    faBarcode,
    faBars,
    faBicycle,
    faBold,
    faBolt,
    faBook,
    faBrain,
    faBriefcase,
    faBug,
    faBuilding,
    faBullhorn,
    faBus,
    faCalculator,
    faCalendar,
    faCalendarAlt,
    faCalendarCheck,
    faCalendarDay,
    faCalendarPlus,
    faCalendarTimes,
    faCamera,
    faCar,
    faCarrot,
    faCertificate,
    faChalkboardTeacher,
    faChartBar,
    faChartLine,
    faChartPie,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleNotch,
    faCity,
    faClipboardList,
    faClock,
    faClockRotateLeft,
    faCloud,
    faCloudUploadAlt,
    faCode,
    faCoffee,
    faCog,
    faCogs,
    faCoins,
    faComment,
    faComments,
    faCompass,
    faConciergeBell,
    faCopy,
    faCreditCard,
    faCrop,
    faCube,
    faDatabase,
    faDesktop,
    faDiamond,
    faDna,
    faDoorOpen,
    faDownload,
    faEdit,
    faEnvelope,
    faEnvelopeOpenText,
    faEraser,
    faEuroSign,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faExternalLinkAlt,
    faEye,
    faEyeSlash,
    faFax,
    faFileAlt,
    faFileContract,
    faFileInvoice,
    faFilePdf,
    faFileUpload,
    faFilm,
    faFire,
    faFirstAid,
    faFlag,
    faFlask,
    faFolder,
    faFolderOpen,
    faFrown,
    faGamepad,
    faGavel,
    faGem,
    faGift,
    faGlassMartini,
    faGlobe,
    faGraduationCap,
    faGripVertical,
    faHamburger,
    faHammer,
    faHandshake,
    faHashtag,
    faHeading,
    faHeadphones,
    faHeadset,
    faHeart,
    faHeartbeat,
    faHighlighter,
    faHistory,
    faHome,
    faHospital,
    faIceCream,
    faIdCard,
    faImage,
    faImages,
    faInfoCircle,
    faItalic,
    faKey,
    faKeyboard,
    faLandmark,
    faLaptopCode,
    faLaughBeam,
    faLayerGroup,
    faLeaf,
    faLightbulb,
    faLink,
    faListOl,
    faListUl,
    faLock,
    faMagic,
    faMagnifyingGlass,
    faMap,
    faMapMarkerAlt,
    faMapPin,
    faMarker,
    faMask,
    faMedal,
    faMicrochip,
    faMicrophone,
    faMicroscope,
    faMinus,
    faMobileAlt,
    faMoneyBillWave,
    faMoon,
    faMouse,
    faMusic,
    faNetworkWired,
    faNewspaper,
    faPaintBrush,
    faPalette,
    faPaperPlane,
    faPaperclip,
    faPen,
    faPenNib,
    faPencilAlt,
    faPercent,
    faPhone,
    faPills,
    faPizzaSlice,
    faPlane,
    faPlay,
    faPlus,
    faPlusCircle,
    faPowerOff,
    faPrint,
    faPuzzlePiece,
    faQrcode,
    faQuestion,
    faQuestionCircle,
    faQuoteLeft,
    faQuoteRight,
    faRandom,
    faRedo,
    faRocket,
    faSave,
    faSchool,
    faSearch,
    faSeedling,
    faServer,
    faShapes,
    faShareAlt,
    faShieldAlt,
    faShip,
    faShoppingBag,
    faShoppingCart,
    faSignOutAlt,
    faSignature,
    faSitemap,
    faSmile,
    faSort,
    faSortDown,
    faSortUp,
    faSpinner,
    faStar,
    faStarHalfAlt,
    faStethoscope,
    faStore,
    faSun,
    faSync,
    faSyringe,
    faTachometerAlt,
    faTag,
    faTags,
    faTerminal,
    faThumbsDown,
    faThumbsUp,
    faTimes,
    faToggleOn,
    faTools,
    faTrash,
    faTrashAlt,
    faTree,
    faTrophy,
    faTruckMonster,
    faUnderline,
    faUndo,
    faUniversity,
    faUnlock,
    faUpload,
    faUser,
    faUserCheck,
    faUserEdit,
    faUserFriends,
    faUserGraduate,
    faUserPlus,
    faUserShield,
    faUserSlash,
    faUserTag,
    faUsers,
    faUsersCog,
    faUtensils,
    faVial,
    faVideo,
    faVirus,
    faVolumeUp,
    faWallet,
    faWheelchair,
    faWifi,
    faWrench
} from '@fortawesome/free-solid-svg-icons'

// Regular icons (far)
import {
    faCalendar as farCalendar,
    faCalendarAlt as farCalendarAlt,
    faCalendarCheck as farCalendarCheck,
    faCalendarPlus as farCalendarPlus,
    faClock as farClock,
    faFilePdf as farFilePdf,
    faStar as farStar
} from '@fortawesome/free-regular-svg-icons'

// Brand icons (fab)
import {
    faAndroid,
    faAppStore,
    faAppStoreIos,
    faApple,
    faArtstation,
    faBandcamp,
    faBluesky,
    faBehance,
    faCodepen,
    faDev,
    faDeviantart,
    faDiscord,
    faDribbble,
    faFacebook,
    faFacebookF,
    faFigma,
    faGithub,
    faGitlab,
    faGoogle,
    faGooglePlay,
    faInstagram,
    faItchIo,
    faLinkedin,
    faLinkedinIn,
    faLinux,
    faMastodon,
    faMedium,
    faPatreon,
    faPinterest,
    faPlaystation,
    faReddit,
    faSlack,
    faSnapchat,
    faSnapchatGhost,
    faSoundcloud,
    faSpotify,
    faStackOverflow,
    faSteam,
    faTelegram,
    faTiktok,
    faTwitch,
    faTwitter,
    faUnity,
    faVimeo,
    faWhatsapp,
    faWindows,
    faXTwitter,
    faXbox,
    faYoutube
} from '@fortawesome/free-brands-svg-icons'

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

library.add(
    // Solid
    faAddressCard,
    faAlignCenter,
    faAlignJustify,
    faAlignLeft,
    faAlignRight,
    faAnchor,
    faAngleLeft,
    faAngleRight,
    faAppleAlt,
    faArchive,
    faArrowDown,
    faArrowLeft,
    faArrowPointer,
    faArrowRight,
    faArrowUp,
    faAt,
    faAtom,
    faAward,
    faBalanceScale,
    faBan,
    faBarcode,
    faBars,
    faBicycle,
    faBold,
    faBolt,
    faBook,
    faBrain,
    faBriefcase,
    faBug,
    faBuilding,
    faBullhorn,
    faBus,
    faCalculator,
    faCalendar,
    faCalendarAlt,
    faCalendarCheck,
    faCalendarDay,
    faCalendarPlus,
    faCalendarTimes,
    faCamera,
    faCar,
    faCarrot,
    faCertificate,
    faChalkboardTeacher,
    faChartBar,
    faChartLine,
    faChartPie,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleNotch,
    faCity,
    faClipboardList,
    faClock,
    faClockRotateLeft,
    faCloud,
    faCloudUploadAlt,
    faCode,
    faCoffee,
    faCog,
    faCogs,
    faCoins,
    faComment,
    faComments,
    faCompass,
    faConciergeBell,
    faCopy,
    faCreditCard,
    faCrop,
    faCube,
    faDatabase,
    faDesktop,
    faDiamond,
    faDna,
    faDoorOpen,
    faDownload,
    faEdit,
    faEnvelope,
    faEnvelopeOpenText,
    faEraser,
    faEuroSign,
    faExclamationCircle,
    faExclamationTriangle,
    faExpand,
    faExternalLinkAlt,
    faEye,
    faEyeSlash,
    faFax,
    faFileAlt,
    faFileContract,
    faFileInvoice,
    faFilePdf,
    faFileUpload,
    faFilm,
    faFire,
    faFirstAid,
    faFlag,
    faFlask,
    faFolder,
    faFolderOpen,
    faFrown,
    faGamepad,
    faGavel,
    faGem,
    faGift,
    faGlassMartini,
    faGlobe,
    faGraduationCap,
    faGripVertical,
    faHamburger,
    faHammer,
    faHandshake,
    faHashtag,
    faHeading,
    faHeadphones,
    faHeadset,
    faHeart,
    faHeartbeat,
    faHighlighter,
    faHistory,
    faHome,
    faHospital,
    faIceCream,
    faIdCard,
    faImage,
    faImages,
    faInfoCircle,
    faItalic,
    faKey,
    faKeyboard,
    faLandmark,
    faLaptopCode,
    faLaughBeam,
    faLayerGroup,
    faLeaf,
    faLightbulb,
    faLink,
    faListOl,
    faListUl,
    faLock,
    faMagic,
    faMagnifyingGlass,
    faMap,
    faMapMarkerAlt,
    faMapPin,
    faMarker,
    faMask,
    faMedal,
    faMicrochip,
    faMicrophone,
    faMicroscope,
    faMinus,
    faMobileAlt,
    faMoneyBillWave,
    faMoon,
    faMouse,
    faMusic,
    faNetworkWired,
    faNewspaper,
    faPaintBrush,
    faPalette,
    faPaperPlane,
    faPaperclip,
    faPen,
    faPenNib,
    faPencilAlt,
    faPercent,
    faPhone,
    faPills,
    faPizzaSlice,
    faPlane,
    faPlay,
    faPlus,
    faPlusCircle,
    faPowerOff,
    faPrint,
    faPuzzlePiece,
    faQrcode,
    faQuestion,
    faQuestionCircle,
    faQuoteLeft,
    faQuoteRight,
    faRandom,
    faRedo,
    faRocket,
    faSave,
    faSchool,
    faSearch,
    faSeedling,
    faServer,
    faShapes,
    faShareAlt,
    faShieldAlt,
    faShip,
    faShoppingBag,
    faShoppingCart,
    faSignOutAlt,
    faSignature,
    faSitemap,
    faSmile,
    faSort,
    faSortDown,
    faSortUp,
    faSpinner,
    faStar,
    faStarHalfAlt,
    faStethoscope,
    faStore,
    faSun,
    faSync,
    faSyringe,
    faTachometerAlt,
    faTag,
    faTags,
    faTerminal,
    faThumbsDown,
    faThumbsUp,
    faTimes,
    faToggleOn,
    faTools,
    faTrash,
    faTrashAlt,
    faTree,
    faTrophy,
    faTruckMonster,
    faUnderline,
    faUndo,
    faUniversity,
    faUnlock,
    faUpload,
    faUser,
    faUserCheck,
    faUserEdit,
    faUserFriends,
    faUserGraduate,
    faUserPlus,
    faUserShield,
    faUserSlash,
    faUserTag,
    faUsers,
    faUsersCog,
    faUtensils,
    faVial,
    faVideo,
    faVirus,
    faVolumeUp,
    faWallet,
    faWheelchair,
    faWifi,
    faWrench,

    // Regular
    farCalendar,
    farCalendarAlt,
    farCalendarCheck,
    farCalendarPlus,
    farClock,
    farFilePdf,
    farStar,

    // Brands
    faAndroid,
    faAppStore,
    faAppStoreIos,
    faApple,
    faArtstation,
    faBandcamp,
    faBluesky,
    faBehance,
    faCodepen,
    faDev,
    faDeviantart,
    faDiscord,
    faDribbble,
    faFacebook,
    faFacebookF,
    faFigma,
    faGithub,
    faGitlab,
    faGoogle,
    faGooglePlay,
    faInstagram,
    faItchIo,
    faLinkedin,
    faLinkedinIn,
    faLinux,
    faMastodon,
    faMedium,
    faPatreon,
    faPinterest,
    faPlaystation,
    faReddit,
    faSlack,
    faSnapchat,
    faSnapchatGhost,
    faSoundcloud,
    faSpotify,
    faStackOverflow,
    faSteam,
    faTelegram,
    faTiktok,
    faTwitch,
    faTwitter,
    faUnity,
    faVimeo,
    faWhatsapp,
    faWindows,
    faXTwitter,
    faXbox,
    faYoutube
)

export default defineNuxtPlugin((nuxtApp) => {
    // Register the SSR-safe wrapper component instead of the raw FontAwesomeIcon
    // This prevents hydration mismatches by using ClientOnly internally
    nuxtApp.vueApp.component('font-awesome-icon', defineAsyncComponent(() =>
        import('~/components/global/FontAwesomeIconSSR.vue')
    ))
})
